import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { OfferService } from '../../../_services/offer.service';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-delete-offer',
  templateUrl: './delete-offer.component.html',
  styleUrls: ['./delete-offer.component.css']
})
export class DeleteOfferComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  private to_delete;

  constructor(private service: OfferService) { }

  ngOnInit() {
  }

  openModal(offer_id){
    this.to_delete = offer_id;
    jQuery('#delete-offer-modal').modal({closable: false}).modal('show');
  }

  deleteOffer(){
    if(!this.to_delete) { // Return false if the ID of the Offer is not stored
      jQuery('#delete-offer-modal').modal('hide');
      return false;
    } 
    let offer_id = this.to_delete // Store it in a var
    this.to_delete = undefined; // Invalidate the Offer to delete (avoid spamming during the deletion process)
    jQuery('#delete-offer-modal').modal({closable: false}); // Set the modal unclosable during the deletion process
    this.service.deleteOffer(offer_id) // Delete the Offer
      .subscribe(response => {
        jQuery('#delete-offer-modal').modal('hide');
        this.refresh.emit(true); // Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/offer/delete-offer/delete-offer.component.ts